<div class="name item">
  <div>{{ 'label.Name' | translate }}</div>
  <input
    class="value"
    style="width: 524px"
    type="text"
    [(ngModel)]="templateData.name"
  />
  <hr-field-state-marker [field]="fieldStates?.name"></hr-field-state-marker
  ><br />
</div>

<div *ngIf="type == bannerType.Image" class="image item">
  <label class="upload-button">
    <input
      type="file"
      ngFileSelect
      [options]="uploadOptions"
      [uploadInput]="uploadInput"
      (uploadOutput)="onUploadOutput($event)"
    />
    <hr-field-state-marker
      *ngIf="type == bannerType.Image"
      [field]="fieldStates?.imageFileName"
    ></hr-field-state-marker
    ><br />
  </label>
</div>

<div *ngIf="type == bannerType.Image" class="link item">
  <div>{{ 'label.Link' | translate }}</div>
  <input style="width: 524px" type="text" [(ngModel)]="templateData.link" />
  <hr-field-state-marker
    *ngIf="type == bannerType.Image"
    [field]="fieldStates?.link"
  ></hr-field-state-marker
  ><br />
</div>

<div *ngIf="type == bannerType.Html" class="code item">
  <div>{{ 'label.InsertCodeHere' | translate }}</div>
  <textarea
    [(ngModel)]="templateData.code"
    style="width: 524px"
    rows="5"
  ></textarea>
  <hr-field-state-marker
    *ngIf="type == bannerType.Html"
    [field]="fieldStates?.code"
  ></hr-field-state-marker
  ><br />
</div>

<div class="item">
  <div style="display: inline-block; margin-right: 10px">
    <input type="checkbox" [(ngModel)]="templateData.isOpenNewTab" />
  </div>
  <div style="display: inline-block">{{ 'label.OpenNewTab' | translate }}</div>
</div>

<div class="item">
  <div>{{ 'label.DeactivateDate' | translate }}</div>
  <div>
    <p-datepicker
      [(ngModel)]="templateData.deactivationDate"
      [showIcon]="true"
    ></p-datepicker>
  </div>
</div>

<p-button
  type="button"
  class="button-save ui-button-secondary"
  (click)="onSave()"
  label="{{ 'label.Save' | translate }}"
></p-button>
<p-button
  type="button"
  class="button-cancel ui-button-secondary"
  (click)="onCancel()"
  label="{{ 'label.Cancel' | translate }}"
></p-button>
